import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class ContentSourceStatus extends Enum {
  key!: string;
  value!: string;

  static ALL = {
    key: 'all',
    get value(): string {
      return Lang.t('ai.all');
    }
  };

  static DRAFT = {
    key: 'draft',
    get value(): string {
      return Lang.t('ai.draft');
    }
  };

  static EMBEDDING = {
    key: 'embedding',
    get value(): string {
      return Lang.t('ai.embedding');
    }
  };

  static FAILED = {
    key: 'failed',
    get value(): string {
      return Lang.t('ai.failed');
    }
  };

  static PUBLISHED = {
    key: 'published',
    get value(): string {
      return Lang.t('ai.published');
    }
  };

  static SCANNING = {
    key: 'scanning',
    get value(): string {
      return Lang.t('ai.scanning');
    }
  };
}
